export default {
  stateKey: 'link',
  order: 6,
  native: true,
}
